module.exports = __webpack_public_path__ + "static/media/gsLogo.aca2a8fa.png";